require
.config({
  config: {
    text: {
      useXhr: function () {
        'use strict';
        return true;
      }
    }
  }
});

define('ccl',['module'], function RequireJSCCL(module) {
  'use strict';

  var masterConfig = null;
  var localMappedKeys = [];

  var getCclRootFromAofljs = function getCclRootFromAofljs(_aofljsPath) {
    var aofljsTest = /\/js\/aofl-js.*/;
    return _aofljsPath.replace(aofljsTest, '');
  };

  var getCclRootFromReqCcl = function getCclRootFromReqCcl(_reqCclPath) {
    var reqCclTest = /\/js\/requirejs-ccl.*/;
    return _reqCclPath.replace(reqCclTest, '');
  };

  var getCclRoot = function getCclRoot() {
    var cclRoot = '';

    if (typeof masterConfig.paths['aofl-js'] !== 'undefined') {
      cclRoot = getCclRootFromAofljs(masterConfig.paths['aofl-js']);
    } else if (typeof masterConfig.paths.ccl !== 'undefined') {
      cclRoot = getCclRootFromReqCcl(masterConfig.paths.ccl);
    } else {
      var moduleUriParts = module.uri.split('/');
      var cclParts = moduleUriParts.slice(0, moduleUriParts.length - 4);
      cclRoot = cclParts.join('/');
    }

    return cclRoot;
  };


  return {
    load: function load(name, req, onload, config) {
      masterConfig = config;
      var cclRoot = getCclRoot();
      if (config.isBuild) {
        req([name], onload);
      } else {
        if (name.indexOf('!') >= 0) { // is another module shortcut
          var path = name.split('.')[0].split('!')[1];
          if (masterConfig.paths[path].indexOf(cclRoot) === -1) {
            masterConfig.paths[path] = cclRoot + '/' + masterConfig.paths[path];
          }
        } else {
          var localMapped = localMappedKeys.indexOf(name);
          if (/^\#mapped\//.exec(masterConfig.paths[name]) !== null || localMapped > -1) {
            if (localMapped === -1) {
              localMappedKeys.push(name);
            }
            masterConfig.paths[name] = masterConfig.paths[name].replace(/^\#mapped\//, '');
          } else if (masterConfig.paths[name] &&
          masterConfig.paths[name].indexOf(cclRoot) === -1) {
            masterConfig.paths[name] = cclRoot + '/' + masterConfig.paths[name];
          } else {
            var bundles = masterConfig.bundles;
            for (var bundle in bundles) {
              if (bundle.indexOf(name) !== -1) {
                name = bundle;
                break;
              }
            }
          }
        }

        req([name], onload);
      }
    }
  };
});

